<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-musical-notation`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M30.137 7.167C28.81 6.25 27 7.2 27 8.812V24A9.956 9.956 0 0021 22c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10c0-.164-.004-.328-.012-.49V12.474l6.785 4.824 2.212-3.328-9.848-6.803zM15 32a6 6 0 1112 0 6 6 0 01-12 0z"/></svg>
</template>
<script>

export default {
  name: 'IconMusicalNotation',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
